import React from 'react';
import './estilo.scss';
import skill_html from '../../assets/html5.png'
import skill_jquery from '../../assets/jquery.png'
import skill_js from '../../assets/javascript.png'
import skill_css from '../../assets/css3.png'
import skill_materialize from '../../assets/materialize.png'
import skill_react from '../../assets/react.png'
import skill_vue from '../../assets/vue.png'
import skill_sass from '../../assets/sass.png'
import skill_bootstrap from '../../assets/bootstrap.png'
import skill_angular from '../../assets/angular.png'
import skill_java from '../../assets/java.png'
import skill_node from '../../assets/nodejs.png'
import skill_spring from '../../assets/spring.png'
import skill_webpack from '../../assets/webpack.png'
import skill_gulp from '../../assets/gulp.png'
import skill_pm2 from '../../assets/pm2.png'
import 'materialize-css/dist/css/materialize.min.css'
import CardSkillsRow from '../CardSkillsRow';

function Skills() {
    const web = {
        obj: [{ stack: "HTML", imgUrl: skill_html },
        { stack: "Javascript", imgUrl: skill_js },
        { stack: "CSS", imgUrl: skill_css }
        ]
    }
    const style = {
        obj: [{ stack: "Jquery", imgUrl: skill_jquery },
        { stack: "Materialize", imgUrl: skill_materialize },
        { stack: "Sass", imgUrl: skill_sass },
        { stack: "Bootsrap", imgUrl: skill_bootstrap }
        ]
    }
    const framework = {
        obj: [{ stack: "React", imgUrl: skill_react },
        { stack: "Vue", imgUrl: skill_vue },
        { stack: "Angular", imgUrl: skill_angular }
        ]
    }
    const back = {
        obj: [{ stack: "Java", imgUrl: skill_java },
        { stack: "Spring", imgUrl: skill_spring },
        { stack: "Node", imgUrl: skill_node }
        ]
    }
    const buildTools = {
        obj: [{ stack: "Webpack", imgUrl: skill_webpack },
        { stack: "Gulp", imgUrl: skill_gulp },
        { stack: "PM2", imgUrl: skill_pm2 }
        ]
    }
    return (
        <div className="container" id="skills">
            <div className="card">
                <div className="card-content">
                    <h4 className="light skills-title">FrontEnd</h4>
                    <CardSkillsRow stack={web} ></CardSkillsRow>
                    <CardSkillsRow stack={style} ></CardSkillsRow>
                    <CardSkillsRow stack={framework} ></CardSkillsRow>
                </div>

            </div>
            <div className="card">
                <div className="card-content">
                    <h4 className="light skills-title">BackEnd</h4>
                    <CardSkillsRow stack={back} ></CardSkillsRow>
                </div>
            </div>
            <div className="card">
                <div className="card-content">
                    <h4 className="light skills-title">Build Tools</h4>
                    <CardSkillsRow stack={buildTools} ></CardSkillsRow>
                </div>
            </div>
        </div>
    );
}

export default Skills;
